import {
  fetchApiDeleteV2,
  fetchApiGetV2,
  fetchApiPostV2,
  fetchApiPutV2,
} from "../../../../api/api";
import {
  updateTypographies,
  updateTypographyById,
  removeTypographyById,
  createTypography,
} from "./typographiesActions";

export interface Typography {
  id: number;
  name: string;
  tag: string;
  uuid: string;
  fontFamily: string;
  fontSize: string;
  fontSizeUnit: string;
  fontStyle: string;
  fontWeight: string;
  letterSpacing: string;
  lineHeight: string;
  activeComponents: string[];
  colorId: number;
  linkColorId: number;
  linkHoverColorId: number;
  transitionDuration: string;
  transitionEffect: string;
}

export type CreateTypographyInput = Omit<Typography, "id" | "uuid">;

const TypographiesAPI = {
  addTypography,
  loadTypographies,
  saveTypographyById,
  deleteTypographyById,
};
export default TypographiesAPI;

function loadTypographies() {
  return fetchApiGetV2<Typography[]>(`/typographies`, {}).then((res) =>
    updateTypographies(res)
  );
}

function addTypography(data: CreateTypographyInput) {
  return fetchApiPostV2<Typography>(`/typographies`, data).then((d) => {
    createTypography(d);
  });
}

function saveTypographyById(data: Typography) {
  return fetchApiPutV2(`/typographies/${data.id}`, data).then(() => {
    updateTypographyById({ id: data.id, data });
  });
}

function deleteTypographyById(id: number) {
  return fetchApiDeleteV2(`/typographies/${id}`, {}).then(() => {
    removeTypographyById(id);
  });
}
